import { useDispatch } from "react-redux";
import { useState } from "react";
import PropTypes from 'prop-types';
import { Button, Tooltip } from '@mui/material';
import { markAsRead } from '../../../redux/slices/orders';

OrdersLeftLabel.propTypes = {
  params: PropTypes.object,
}

export default function OrdersLeftLabel({ params }) {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const isRead = params.row.read ?? false;

  return (
    <Tooltip title={`Click to mark as ${isRead ? 'unread' : 'read'}`}>
      <Button
        size="small"
        variant="contained"
        onClick={async (event) => {
          event.stopPropagation();
          event.preventDefault();
          if (saving) return;
          setSaving(true);
          params.api.updateRows([
            {
              id: params.row.id,
              read: !isRead,
            }
          ]);
          await dispatch(markAsRead(params.row.id, !isRead));
          setSaving(false);
        }}
        sx={{
          mb: '2px',
          pl: 0,
          maxWidth: '10px',
          minWidth: '10px',
          width: '10px',
          height: '100%',
          borderRadius: 0,
          backgroundColor: isRead ? '#fff' : '#208ee0',
          '&:hover': {
            cursor: 'pointer',
            backgroundColor: isRead ? '#fff' : '#208ee0',
            opacity: 0.8,
          }
        }}
      />
    </Tooltip>
  );
}